import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import EvidenceCard from '../components/EvidenceCard';
import { evidenceItems } from '../utils/mockData';
const EvidenceReview = () => {
  const [filter, setFilter] = useState('all');
  const filteredEvidence = filter === 'all' ? evidenceItems : evidenceItems.filter(item => item.validationStatus === filter);
  return <div data-id="element-136">
      <div className="mb-6" data-id="element-137">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-138">Evidence Review</h1>
        <p className="mt-1 text-sm text-gray-600" data-id="element-139">
          Quality assurance and validity checking
        </p>
      </div>
      <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-140">
        <div className="relative rounded-md w-full sm:w-64" data-id="element-141">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-142">
            <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-143" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search evidence..." data-id="element-144" />
        </div>
        <select className="block w-full sm:w-auto pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={filter} onChange={e => setFilter(e.target.value)} data-id="element-145">
          <option value="all" data-id="element-146">All Evidence</option>
          <option value="validated" data-id="element-147">Validated</option>
          <option value="conflicting" data-id="element-148">Conflicting</option>
          <option value="unverified" data-id="element-149">Unverified</option>
        </select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-150">
        {filteredEvidence.map((item, index) => <EvidenceCard key={index} title={item.title} source={item.source} submissionCount={item.submissionCount} validationStatus={item.validationStatus as any} priority={item.priority as any} confidence={item.confidence} data-id="element-151" />)}
      </div>
      {filteredEvidence.length === 0 && <div className="text-center py-12" data-id="element-152">
          <p className="text-gray-500" data-id="element-153">
            No evidence matches your current filters.
          </p>
        </div>}
    </div>;
};
export default EvidenceReview;